import React from 'react';
import { Row, Col, Card, Button } from 'react-bootstrap';
import ContactForm from './ContactForm';
import soccerSchoolImageSmall from '../imgs/soccer-school-small.png';
import { Link } from 'react-router-dom';
import 'bootstrap-icons/font/bootstrap-icons.css';

const InfoPanels: React.FC = () => {

  return (
    <Row className="g-4">

      {/* Panel 1: Contact Us */}
      <Col lg={4} md={12}>
        <Card className="h-40 info-panel">
          <Card.Body>
            <Card.Title>ASHRIDGE PARK F.C</Card.Title>
            <Card.Text>
              <p>
                Welcome to Ashridge Park Football Club!
              </p>
              <p>
                We are a community-focused club offering football opportunities for all ages and abilities.
              </p>
              <div className="d-flex justify-content-center">
                <Button variant="outline-light" href="/teams" className="me-2 mb-3">
                  See Our Teams
                </Button>
              </div>
              <div style={{
                background: 'linear-gradient(135deg, var(--navy-900) 0%, var(--navy-700) 100%)',
                borderRadius: '12px',
                padding: '1.25rem',
                boxShadow: '0 8px 24px -12px rgba(19, 42, 82, 0.9)',
                border: '2px solid rgba(255, 210, 63, 0.55)',
                textAlign: 'center'
              }}>
                <i className="bi bi-trophy-fill" style={{ fontSize: '2.5rem', color: 'var(--gold-bright)', marginBottom: '0.5rem', display: 'block' }}></i>
                <h5 style={{ color: '#fff', marginBottom: '0.5rem', fontWeight: 'bold' }}>
                  Ashridge Park Tournament 2026
                </h5>
                {/* <p style={{ color: 'rgba(255, 255, 255, 0.95)', marginBottom: '0.75rem', fontSize: '0.95rem' }}>
                  June 6th-7th at St. Crispins School
                </p> */}

                <p className="tournament-overlay-cta">
                
                 <a href="https://tournacore.com/t/ashridge-summer-tournament-2026" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: '#fff', fontWeight: 'bold', fontSize: '1rem' }}>
                    {/* <span style={{ display: 'inline-flex', alignItems: 'center', gap: '0.4rem', background: 'rgba(255, 59, 48, 0.95)', color: '#fff', fontSize: '0.7rem', fontWeight: 700, letterSpacing: '0.08em', padding: '0.2rem 0.55rem', borderRadius: '999px', textTransform: 'uppercase' }}>
                      <span style={{ width: '8px', height: '8px', borderRadius: '50%', background: '#fff', boxShadow: '0 0 0 0 rgba(255, 255, 255, 0.7)', animation: 'heroLivePulseDot 1.4s ease-out infinite' }}></span>
                      LIVE
                    </span>
                    &nbsp; */}
                    <span style={{textDecoration: 'none'}}>Results</span>
                    &nbsp;
                    <i className="bi bi-arrow-right-circle-fill tournament-overlay-arrow"></i>
                  </a>
                </p>
                {/* <p style={{ color: '#ffd700', fontWeight: 'bold', marginBottom: '1rem', fontSize: '1.1rem' }}>
                  Registration is NOW OPEN!
                </p> */}
                {/* <br />
                <Button
                  as={Link as any}
                  to="/tournament-registration"
                  style={{
                    background: '#fff',
                    color: '#764ba2',
                    fontWeight: 'bold',
                    border: 'none',
                    padding: '0.6rem 1.5rem',
                    borderRadius: '8px',
                    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.2)'
                  }}
                >
                  Register Your Team
                </Button> */}
              </div>
            </Card.Text>
          </Card.Body>
        </Card>
        <br/><br />
        <ContactForm />
      </Col>

      {/* Panel 2: Combined Match Day & Quick Links */}
      <Col lg={4} md={12}>
        <Card className="h-100 info-panel">
          <Card.Body className="d-flex flex-column">
            <Card.Title>MATCH DAY</Card.Title>
            <Card.Text>
              <p>Home games are played at St. Crispins School and Cantley Park in Wokingham.</p>
            </Card.Text>
            <div className="d-flex justify-content-center">
              <Button variant="outline-light" href="/matchdayinfo" className="me-2 mb-3">
                Matchday Info
              </Button>
              <Button as="a" variant="outline-light" href="/content/2025-26-Fixture-Notification-Template.docx" download className="mb-3">
                Download Fixture Template
              </Button>
            </div>
            <hr style={{ borderColor: 'rgba(255, 255, 255, 0.3)' }} />
            <Card.Text>
              <h5>St. Crispins School</h5>
              <Card.Subtitle className="mb-2 text-muted">St. Crispins School, London Rd, Wokingham RG40 1SS</Card.Subtitle>
              <p>The school has strict <b>No Dogs</b> and <b>No Smoking</b> policies</p>
            </Card.Text>
            <div className='ratio ratio-16x9'>
                <iframe title="crispins" width="600" height="450" loading="lazy" src="https://www.google.com/maps/embed/v1/place?q=place_id:ChIJkSI5Hz-BdkgRwB8TdzYEPAM&key=AIzaSyANv2W59WYEoo-8kTOmBAwVTOlu4NS3dDU"></iframe>
            </div>
            <hr style={{ borderColor: 'rgba(255, 255, 255, 0.3)' }} />

            <Card.Text>
              <h5>Cantley Park</h5>
              <Card.Subtitle className="mb-2 text-muted">Cantley Park, Wokingham RG40 5QG</Card.Subtitle>
            </Card.Text>
            <div className='ratio ratio-16x9'>
                <iframe title="cantley" width="600" height="450" loading="lazy" src="https://www.google.com/maps/embed/v1/place?q=place_id:ChIJ11rNS4uBdkgRJOviv6bLM3s&key=AIzaSyANv2W59WYEoo-8kTOmBAwVTOlu4NS3dDU"></iframe>
            </div>

            {/* <hr style={{ borderColor: 'rgba(255, 255, 255, 0.3)' }} />
            <div>
              <div className="d-flex justify-content-center">
                <Button variant="outline-light" href="/matchdayinfo" className="me-2 mb-3">
                  Matchday Info
                </Button>
              </div>
              <div className="d-flex justify-content-center">
                <Button as="a" variant="outline-light" href="/content/2025-26-Fixture-Notification-Template.docx" download className="mb-3">
                  Download Matchday Info (Word Doc)
                </Button>
              </div>
            </div> */}

            {/* <ListGroup variant="flush" className="mt-auto">
              <ListGroup.Item action href="/playerswanted" className="info-panel-list-item">
                Players Wanted
              </ListGroup.Item>
              <ListGroup.Item action href="/clubinfo" className="info-panel-list-item">
                Club Info
              </ListGroup.Item>
              <ListGroup.Item action href="/tournament" className="info-panel-list-item">
                Tournament
              </ListGroup.Item>
            </ListGroup> */}
          </Card.Body>
        </Card>
      </Col>


      {/* Panel 3: Welcome */}
      <Col lg={4} md={12}>
       <Card className="h-40 info-panel">
          <Card.Body>
            <Card.Title>SOCCER SCHOOL</Card.Title>
            <div className="image-container">
              <Link to="/soccerschool">
                <Card.Img 
                  src={soccerSchoolImageSmall} 
                  alt="Soccer School training session" 
                  className="rounded-3"
                  style={{ 
                  //   height: '650px', 
                    objectFit: 'cover',
                    filter: 'brightness(1.05) contrast(1.1)'
                  }}
                />
              </Link>
            </div>
            <div className="mt-3 text-center">
              <Button variant="outline-light" href="/soccerschool" className="me-2 mb-3">
                More Info
              </Button>
            </div>
          </Card.Body>
        </Card>
        <br/><br />
        <Card className="h-60 info-panel">
          <Card.Body>
            <Card.Title>ABOUT THE CLUB</Card.Title>
            <Card.Text>
              <p>
                Ashridge Park Football Club is based in Wokingham, Berkshire and was founded in 1991.
              </p>
              <p>
                Ashridge Park FC quickly grew from a single idea into a thriving community club.
                Within a few years, it boasted over 100 members, hosted its first summer tournament, and represented Wokingham abroad, even bringing home trophies from France. 
              </p>
              <p>
                With teams ranging from U7s to adult squads including girls' teams, we pride ourselves on fostering a love for the game while promoting teamwork and sportsmanship.
              </p>
              <p>
                Today, Ashridge Park FC has over 400 members across more than 30 teams, runs the popular Ashridge Park tournament each summer, and recently participated in the FA Cup for the first time.
              </p>
            </Card.Text>
            <div className="mt-3 text-center">
              <Button variant="outline-light" href="/clubinfo" className="me-2 mb-3">
                Our Club
              </Button>
              <Button variant="outline-light" href="/clubinfo#history" className="me-2 mb-3">
                Club History
              </Button>
            </div>
            {/* <hr style={{ borderColor: 'rgba(255, 255, 255, 0.3)' }} />
            <div className="image-container">
              <Card.Img 
                src={soccerSchoolImageSmall} 
                alt="Soccer School training session" 
                className="rounded-3"
                style={{ 
                //   height: '650px', 
                  objectFit: 'cover',
                  filter: 'brightness(1.05) contrast(1.1)'
                }}
              />
            </div> */}
          </Card.Body>
        </Card>
        <br/><br />
        <Card className="info-panel">
          <Card.Body>
            <Card.Title>COACHES</Card.Title>
            <Card.Text>
              <p>Resources, forms and information for Ashridge Park FC coaches.</p>
            </Card.Text>
            <div className="text-center">
              <Button variant="outline-light" href="/coachescorner" className="mb-2">
                Coaches Corner
              </Button>
            </div>
          </Card.Body>
        </Card>
      </Col>


    </Row>
  );
};

export default InfoPanels;